import { fetchProjectProperties } from './fetch-project-properties/index.tsx';

export const actions = {
	fetchProjectProperties,
} as const;
